<template>
    <span class="tag-wrap">
        <div v-if="!dealer && isBanker" :class="{ 'tag-z': true, 'left-0': atRight, 'right-0': !atRight }">
            {{ $t('goldenFlower.banker') }}
        </div>
        <div v-if="!dealer" :class="{ 'tag-v': true, 'left-0': !atRight, 'right-0': atRight }">
            {{ `V${lv ?? '0'}` }}
        </div>
        <span class="name">
            {{ /\d/.test(userName) ? userName.slice(-5) : userName }}
        </span>
        <span v-if="Number(balance) >= 0" class="balance truncate px-1">
            {{ getFixed(balance) }}
        </span>
        <span v-if="countingDown >= 0 && showProgress" class="count-down"
            :style="{ '--max-second': `${iMaxSeconds}s`, }">
            <span class="background-bar"></span>
            <span class="progress-bar" :style="{ 'width': `${countingDown / iMaxSeconds * 100}%`, }"></span>
            <em class="number">
                {{ countingDown }}
            </em>
        </span>
    </span>
</template>

<script lang="ts" setup>
import { roundTime } from '../ts/constants';

const props = defineProps({
    userName: {
        type: String,
        required: true,
    },
    balance: {
        type: String,
    },
    countingDown: {
        type: Number,
    },
    isBanker: {
        type: Boolean,
    },
    dealer: {
        type: Boolean,
    },
    lv: {
        type: Number,
    },
    showProgress: {
        type: Boolean,
    },
    atRight: {
        type: Boolean,
    }
});

const iMaxSeconds = roundTime;

</script>

<style lang="scss" scoped>
.tag-wrap {
    background: linear-gradient(180deg, #2F2F2F 0%, #151818 100%);
    // width: 65px;
    width: var(--name-tag-width);
    min-height: 22px;
    opacity: 1;
    border-radius: 6px;
    display: inline-flex;
    flex-direction: column;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);
    position: relative;
}

.tag-v,
.tag-z {
    box-shadow: 0px 0px 2px 0px #FFFFFF40 inset;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    // right: 0;
    // left: 0;
    position: absolute;
    top: -8px;
    font-weight: 300;
    font-size: 10px;
    text-align: center;
}

.tag-z {
    background: linear-gradient(180deg, #B830B4 0%, #711B7C 100%);

}

.tag-v {
    background: linear-gradient(180deg, #3BB830 0%, #277C1B 100%);
}

.name,
.balance {
    height: 22px;
    line-height: 22px;
    text-align: center;

}

.name {
    display: inline-block;
    font-weight: 400;
    font-size: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    padding: 0 8px;
    white-space: nowrap;
}

.balance {
    width: 100%;
    color: rgba(253, 217, 53, 1);
    font-weight: 400;
    font-size: 12px;
    position: relative;

    // vertical-align: middle;
    &:before {
        content: '';
        width: 90%;
        height: 1px;
        display: block;
        position: absolute;
        top: 0;
        left: 5%;
        background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 50%, rgba(255, 255, 255, 0) 100%);
        opacity: 0.3;
    }
}

.count-down {
    --height: 3px;
    --color: rgba(126, 248, 83, 1);
    position: absolute;
    left: 0;
    right: 0;
    bottom: calc(var(--height) * 3 * -1 - 2px);
    width: 100%;
    height: calc(var(--height) * 3);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100px;

    .background-bar,
    .progress-bar {
        content: '';
        display: block;
        width: 100%;
        height: var(--height);
        position: absolute;
        left: 0;
        right: 0;
        background: var(--color);
        border-radius: 100px;
        z-index: 1;
        background: rgba(126, 248, 83, 0.3);
    }

    .progress-bar {
        background: var(--color);
        width: 80%;
    }

    .number {
        min-width: 15px;
        text-align: center;
        height: 100%;
        font-size: 10px;
        font-weight: 400;
        border-radius: 3px;
        height: 100%;
        padding: 0 3px;
        background: var(--color);
        z-index: 2;
        position: relative;
        z-index: 2;
        line-height: 1;
        color: black;
    }
}
</style>
